var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69362 10.0002L0.299335 1.27199C0.0630953 0.664515 0.655438 0.0835794 1.2414 0.290074L1.33375 0.329333L19.3337 9.32933C19.852 9.58845 19.8844 10.298 19.4309 10.6134L19.3337 10.671L1.33375 19.671C0.750768 19.9625 0.117464 19.4265 0.268798 18.8239L0.299335 18.7283L3.69362 10.0002L0.299335 1.27199L3.69362 10.0002ZM2.4021 2.54056L5.01109 9.24956L11.6387 9.25015C12.0184 9.25015 12.3322 9.53231 12.3818 9.89838L12.3887 10.0002C12.3887 10.3798 12.1065 10.6936 11.7404 10.7433L11.6387 10.7502L5.01109 10.7496L2.4021 17.4597L17.3213 10.0002L2.4021 2.54056Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhite);
export default __webpack_public_path__ + "static/media/sendWhite.eb5aea2ccf0f567171d26b23365124e9.svg";
export { ForwardRef as ReactComponent };